import { render, staticRenderFns } from "./RedEnvelopeRain.vue?vue&type=template&id=0ca8fddf&scoped=true&"
import script from "./RedEnvelopeRain.vue?vue&type=script&lang=ts&"
export * from "./RedEnvelopeRain.vue?vue&type=script&lang=ts&"
import style0 from "./RedEnvelopeRain.vue?vue&type=style&index=0&id=0ca8fddf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca8fddf",
  null
  
)

export default component.exports